import { Injectable, Type } from '@angular/core';
import { Dictionary } from '../../../type_definitions/vendor';
import { TestComponent } from './components/test.component';
import { BaseCustomComponent } from './base-custom.component';

// this service is to register ga3 custom components to be use in YAML form definitions
// referred to: https://acslworld.atlassian.net/wiki/spaces/DEV/pages/2244345873/GA3+Custom+Input+Field
const componentEntries:Dictionary<Type<BaseCustomComponent>> = {
  testComponent: TestComponent
};

@Injectable()
export class CustomComponentService {
  constructor() {
    /**/
  }

  public getComponent(name:string): Type<BaseCustomComponent> {
    return componentEntries[name];
  }
}